<template>
    <div class="home">
        <div class="logo"><img src="../assets/logo.png" alt="logo"></div>
        <!-- <div class="button-home"><img src="../assets/buttons/button_home.svg" alt="button home"></div> -->
        <!-- <div class="button-map"><router-link to="/kaart"><img src="../assets/buttons/button_map.svg" alt="button map"></router-link></div> -->
        <!-- <div class="button-map-reunies"><router-link to="/reuniekaart"><img src="../assets/buttons/button_map_reunies.svg" alt="button map"></router-link></div> -->
        <div class="header">MUSEUM VAN ZUILEN</div>
        <div class="subheader">WikiWim</div>
        <center><div class="matrix">
            <div class="button-matrix-container">
                <table>
                    <tr height="200px"><td>
                        <router-link to="/kaart">
                            <div class="button-matrix">
                                <img src="../assets/buttons/knop-geschiedenis.jpg" alt="button">
                            </div>
                        </router-link>
                    </td></tr>
                    <tr height="20px"><td>
                        <div class="title">Geschiedenis van Zuilen</div>
                    </td></tr>
                </table>
            </div>
            <div class="button-matrix-container">
                <table>
                    <tr height="200px"><td>
                        <router-link to="/reuniekaart">
                            <div class="button-matrix">
                                <img src="../assets/buttons/knop-reunies.jpg" alt="button">
                            </div>
                        </router-link>
                    </td></tr>
                    <tr height="20px"><td>
                        <div class="title">Straat reünies</div>
                    </td></tr>
                </table>
            </div>
            <div v-bind:key="button.id" v-for="button in matrixItems" class="button-matrix-container">
                <table>
                    <tr height="200px"><td>
                        <div class="button-matrix" @click="showFile(button.type, button.linkId)">
                            <img v-bind:src="button.thumb" alt="button">
                            <div v-if="button.type === 'video'" class="video-indicator"><img src="../assets/buttons/video_indicator.png" alt="video indicator"></div>
                        </div>
                    </td></tr>
                    <tr height="20px"><td>
                        <div class="title">{{ button.title }}</div>
                    </td></tr>
                </table>
            </div>
        </div></center>
    </div>
</template>

<script>
import config from '../config/app.json';
import axios from 'axios';
import router from '../router';

export default {
    name: 'Home',
    data() {
        return {
        pins: [],
        matrixItems: []
        };
    },
    methods: {
        matrixClickHandler: () => {
            console.log('Hallo Matrix');
        },
        showFile: (typeIn, linkIn) => {
            router.push('/' + typeIn + '/' + linkIn);
        }
    },
    created() {
        // pins in map
        // axios.get('http://omeka.virtualbox/api/items?collection=1&key=f5d5fa68bf8b96c2e335594d04f9540858fc1443')
        axios.get(config.api + 'items?collection=1&key=' + config.api_key)
        .then((res) => {
            res.data.forEach(record => {
                var pinItem = {};
                // console.log('record: ' + record.id);
                pinItem.id = record.id;
                record.element_texts.forEach(text_element => {
                    if(text_element.element.name === 'Titel') {
                        // console.log('titel: '+ text_element.text);
                        pinItem.title = text_element.text;
                    }
                    if(text_element.element.name === 'Pin') {
                        // console.log('pin: '+ text_element.text);
                        pinItem.pin = text_element.text;
                    }
                });
                this.pins.push(pinItem);
            });
            // console.log('naar localStorage' + JSON.stringify(this.pins));
            localStorage.setItem('pinItems', JSON.stringify(this.pins));
        })
        .catch(err => console.log(err));
        // matrix items
        // axios.get('http://omeka.virtualbox/api/items?collection=2&key=f5d5fa68bf8b96c2e335594d04f9540858fc1443')
        axios.get(config.api + 'items?collection=3&key=' + config.api_key)
        .then((res) => {
            res.data.forEach(matrixItem => {
                var matrixKnopItem = {};
                // axios.get('http://omeka.virtualbox/api/files?item=' + matrixItem.id + '&key=f5d5fa68bf8b96c2e335594d04f9540858fc1443')
                axios.get(config.api + 'files?item=' + matrixItem.id + '&key=' + config.api_key)
                .then((filesRes) => {
                    // console.log('matrixitem id:' + matrixItem.id);
                    matrixKnopItem.id = matrixItem.id
                    // console.log('item_type: ' + matrixItem.item_type.name);
                    if(matrixItem.item_type.id === 3) {
                        matrixKnopItem.type = 'video';
                    }
                    if(matrixItem.item_type.id === 6) {
                        matrixKnopItem.type = 'still';
                    }
                    

                    matrixItem.element_texts.forEach(text_element => {
                        // console.log('element name: ' + text_element.element.name + ' text: ' + text_element.text);
                        if(text_element.element.name === 'Title') {
                            // console.log('titel: '+ text_element.text);
                            matrixKnopItem.title = text_element.text;
                            // pinItem.title = text_element.text;
                        }
                    });

                    filesRes.data.forEach(fileItem => {
                        // console.log('mime: ' + fileItem.metadata.mime_type);
                        if(fileItem.metadata.mime_type.slice(0, 6) === 'image/') {
                            matrixKnopItem.thumb = fileItem.file_urls.thumbnail;
                        }
                        // link to video
                        if(matrixItem.item_type.id === 3 && fileItem.metadata.mime_type.slice(0, 6) === 'video/') {
                            matrixKnopItem.linkId = fileItem.id;
                        }
                        // link to image
                        if(matrixItem.item_type.id === 6 && fileItem.metadata.mime_type.slice(0, 6) === 'image/') {
                            matrixKnopItem.linkId = fileItem.id;
                        }
                    });
                    // console.log('matrixItem: ' + JSON.stringify(matrixKnopItem));
                    this.matrixItems.push(matrixKnopItem);
                })
                .catch();
            });
        })
        .catch();
    },
}
</script>

<style scoped>
    .logo {
        position: absolute;
        top: 80px;
        left: 1645px;
        width: 120px;
        height: auto;
    }
    .logo img {
    width: 100%;
    height: auto;
    }
    .home {
        background-color: #cccc99;
        width: 1920px;
        height: 1080px;
    }
    .button-home {
        position: absolute;
        top: 117px;
        left: 60px;
        width: 38px;
        height: auto;
        opacity: 50%;
    }
    .button-map {
        position: absolute;
        top: 200px;
        left: 50px;
        width: 50px;
        height: auto;
    }
    .button-map-reunies {
        position: absolute;
        top: 280px;
        left: 50px;
        width: 50px;
        height: auto;
    }
    .header {
        position: absolute;
        font-size: 2em;
        font-family: MuseoSlab, Arial, Helvetica, sans-serif;
        font-weight: 900;
        left: 965px;
        top: 80px;
        color: #c1292f;
    }
    .subheader {
        position: absolute;
        font-size: 1.4em;
        font-family: MuseoSlab, Arial, Helvetica, sans-serif;
        font-weight: 900;
        left: 965px;
        top: 120px;
        color: #c1292f;
    }
    .matrix {
        position: absolute;
        display: flex;
        /* align-items: center; */
        justify-content: flex-start;
        flex-wrap: wrap;
        top: 200px;
        left: 200px;
        width: 1520px;
        height: 780px;
    }
    .button-matrix {
        position: relative;
        display: inline-flex;
        width: 220px;
        height: 220px;
    }
    .button-matrix-container {
        display: inline-block;
        width: 220px;
        height: 220px;
        margin: 10px;
    }
    .button-matrix img {
        object-fit: contain;
        max-height: 100%;
        max-width: 100%;
        margin: auto;
    }
    .video-indicator {
        display: inline-flex;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .video-indicator img {
        object-fit: contain;
        margin: auto;
        max-width: 50%;
        max-height: 50%;
    }
    .button-matrix-container .title {
        margin-top: 5px;
        width: 100%;
        height: 20px;
        /* text-align: center; */
        color: #c1292f;
        font-weight: 700;
        font-size: 12px;
    }
</style>